module.exports = "/dashboard/manage/users/modal-confirm-invite-437ac9.html";